/* Shipping suggestions use the theme threshold and Growth Suite's current prices. */
(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') {
    window.BcbAov = api;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', api.mount);
    else api.mount();
  }
})(function () {
  'use strict';
  // Store fallback approved in the brief. A valid GS payload always overrides it.
  var FALLBACK_TIERS = [{q: 1, p: 0}, {q: 2, p: 5}, {q: 3, p: 12}];
  function tiers(raw) {
    try {
      var value = typeof raw === 'string' ? JSON.parse(raw) : raw;
      var list = Array.isArray(value) ? value : value && (value.t || value.tiers);
      if (!list || !list.length) return FALLBACK_TIERS;
      var parsed = list.map(function (r) { return {q: Number(r.q || r.quantity), p: Number(r.p === undefined ? r.percentage : r.p)}; });
      if (parsed.some(function (r) { return !Number.isInteger(r.q) || r.q < 1 || !Number.isFinite(r.p) || r.p < 0 || r.p >= 100; })) return FALLBACK_TIERS;
      return parsed.sort(function (a, b) { return a.q - b.q; });
    } catch (e) { return FALLBACK_TIERS; }
  }
  function total(price, quantity, list) {
    var rate = 0;
    list.forEach(function (r) { if (quantity >= r.q) rate = r.p; });
    return Math.round(price * (100 - rate) / 100) * quantity;
  }
  function money(cents, currency) {
    return new Intl.NumberFormat('en-US', {style: 'currency', currency: currency, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2}).format(cents / 100);
  }
  function message(price, limit, list, totals, currency) {
    for (var q = 1; q <= 3; q++) {
      var amount = totals && Number.isFinite(totals[q]) ? totals[q] : total(price, q, list);
      if (amount >= limit) return q === 1 ? 'Free shipping on this item' : 'Buy ' + q + ', get free shipping';
    }
    return 'Free shipping on orders over ' + money(limit, currency);
  }
  function displayedTotal(cents, quantity, price, list, perItem, eachMarker, campaign) {
    if (!Number.isFinite(cents) || cents < 0) return undefined;
    var standard = total(price, quantity, list);
    var each = eachMarker || perItem;
    if (each && cents <= price) return cents * quantity;
    if (each) return cents <= price * quantity ? cents : undefined;
    if (!campaign && quantity > 1 && Math.abs(cents - Math.round(standard / quantity)) <= 1 && Math.abs(cents - standard) > quantity) return cents * quantity;
    return cents;
  }
  function plusOne(cart, item, limit, list) {
    if (item.original_price < 100 || /gift\s*wrap|^tip$|shipping protection/i.test(item.product_title || item.title || '')) return false;
    if (cart.total_price >= limit || item.selling_plan_allocation || (cart.cart_level_discount_applications || []).length) return false;
    if (Math.abs(total(item.original_price, item.quantity, list) - item.final_line_price) > item.quantity) return false;
    if (list === FALLBACK_TIERS && item.quantity + 1 > 3) return false;
    return cart.total_price - item.final_line_price + total(item.original_price, item.quantity + 1, list) >= limit;
  }
  function excluded(p) {
    return !p || !p.available || p.requires_selling_plan || /gift\s*wrap|^tip$|shipping protection/i.test(p.title || '') || (p.variants || []).some(function (v) { return /^(BCBPK3-|BCBSET-)/i.test(v.sku || ''); });
  }
  function match(p, items) {
    var vendor = String(p.vendor || '').trim().toLowerCase();
    var type = String(p.type || p.product_type || '').trim().toLowerCase();
    return items.some(function (i) {
      return (vendor && vendor === String(i.vendor || '').trim().toLowerCase()) || (type && type === String(i.product_type || '').trim().toLowerCase());
    });
  }
  function variantFor(p, missing) {
    return (p.variants || []).find(function (v) { return v.available && v.price >= Math.max(missing, 100) && v.price <= missing + 1500; });
  }
  function mount() {
    var node = document.querySelector('[data-bcb-aov-config]');
    if (!node || document.documentElement.dataset.bcbAovMounted) return;
    var config;
    try { config = JSON.parse(node.textContent); } catch (e) { return; }
    document.documentElement.dataset.bcbAovMounted = '1';
    if (config.product) document.documentElement.dataset.bcbAovProduct = '1';
    var root = (config.root || '/').replace(/\/?$/, '/');
    var limit = Number(config.threshold);
    var shipping = config.shippingEnabled && config.currency === 'USD' && limit > 0;
    var block, signature = '', busy = false, scheduled = false, generation = 0, readVersion = 0, observedDrawer, drawerObserver, cartRead, cartEpoch = 0, cartNeedsRead = true, wasDrawerOpen = false, confirmedCart, confirmedEpoch = -1, renderedGsKey;
    var productCache = new Map();
    var searchCache = new Map();
    var catalogPromise;
    var mainShippingLine = document.querySelector('[data-testid="bcb-aov-shipping-main"]');
    var gsPriceState = {id: null, price: null, fingerprint: null, blocked: false};
    function url(path) { return root + path; }
    function getJson(path) {
      return fetch(url(path), {headers: {'Accept': 'application/json'}, cache: 'no-store'}).then(function (r) { if (!r.ok) throw new Error('Request failed'); return r.json(); });
    }
    function cartKey(cart) { return cart && Array.isArray(cart.items) ? JSON.stringify([cart.currency, cart.total_price, cart.items.map(function (i) { return [i.key, i.quantity, i.final_line_price]; })]) : null; }
    function invalidateCart() { cartEpoch++; cartNeedsRead = true; }
    function confirmCart(cart, epoch) {
      if (epoch !== cartEpoch) return false;
      cartRead = null; confirmedCart = cart; confirmedEpoch = epoch; cartNeedsRead = false;
      return true;
    }
    // Opening and GS cart events read the server, coalesced into one in-flight GET.
    // Styles do not start another chain after failure. Silent server changes need
    // an observable cart event, reopening or reattachment; no cache can detect them.
    function displayCart() {
      if (cartRead) return cartRead;
      if (confirmedCart && confirmedEpoch === cartEpoch) return Promise.resolve(confirmedCart);
      if (!cartNeedsRead) return Promise.reject(new Error('Cart needs a new event'));
      cartNeedsRead = false;
      var pending = (async function () {
        for (var attempt = 0; attempt < 3; attempt++) {
          var epoch = cartEpoch;
          var cart = await getJson('cart.js?bcb_aov_check=' + Date.now());
          if (cartRead !== pending) return cart;
          if (epoch !== cartEpoch) continue;
          confirmCart(cart, epoch); return cart;
        }
        throw new Error('Cart kept changing');
      })().catch(function (error) { if (cartRead === pending) cartNeedsRead = false; throw error; }).finally(function () { if (cartRead === pending) cartRead = null; });
      cartRead = pending;
      return cartRead;
    }
    function catalog() {
      if (!catalogPromise) catalogPromise = fetch(config.catalogUrl).then(function (r) { if (!r.ok) throw new Error('Catalog unavailable'); return r.json(); }).catch(function () { return {bestsellers: [], candidates: []}; });
      return catalogPromise;
    }
    function product(handle) {
      if (!productCache.has(handle)) productCache.set(handle, getJson('products/' + encodeURIComponent(handle) + '.js').catch(function () { return null; }));
      return productCache.get(handle);
    }
    function search(term) {
      if (!searchCache.has(term)) searchCache.set(term, getJson('search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide').catch(function () { return {}; }));
      return searchCache.get(term);
    }
    function gs() { return window.gsCartDrawerCore || window.gsCartDrawerManager; }
    // Örneklenmemiş PostHog olayları (theme.liquid before_send muafiyeti); PostHog yoksa sessiz geçer.
    function track(event, props) { try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(event, props); } catch (e) {} }
    // Gösterim olayı çekmece açılışı başına bir kez, blok görünür ve sepet doluyken.
    var announce = false, shownKey = '';
    function shown(cart) {
      // Öneriler yüklenmeden (çizim sürerken) sayılmaz: yalnız çizimi tamamlanmış sepet durumu.
      if (!announce || !block || block.hidden || !cart.items.length || shownKey !== cartKey(cart)) return;
      announce = false;
      var cards = Array.from(block.querySelectorAll('.bcb-aov-card'));
      track('bcb_aov_shown', {missing: Math.max(0, limit - cart.total_price), cart_total: cart.total_price, plus_one: block.querySelectorAll('[data-testid="bcb-aov-quantity-add"]').length, suggestions: cards.length, sources: cards.map(function (c) { return c.dataset.source; }).join(',')});
    }
    function widgetTiers() {
      var w = document.getElementById('gs-volume-discount');
      return tiers(w && w.getAttribute('data-volume-tiers-raw'));
    }
    function selectedVariant() {
      if (!config.product) return null;
      var input = document.querySelector('[data-bcb-pdp-form] input[name="id"]');
      var id = Number(input && input.value);
      return config.product.variants.find(function (v) { return v.id === id; }) || config.product.variants[0];
    }
    function renderedTotals(list, variant) {
      var w = document.getElementById('gs-volume-discount');
      var out = {};
      if (!w || config.currency !== 'USD') return out;
      // This GS attribute is an initial ID: selecting a shade updates its rows
      // and POST body without updating the attribute. Validate the price owner below.
      var fingerprint = Array.from(w.querySelectorAll('.gs-vd-radio-price')).map(function (p) { return p.textContent; }).join('|');
      if (gsPriceState.id === null || fingerprint !== gsPriceState.fingerprint) {
        gsPriceState.id = variant.id; gsPriceState.price = variant.price; gsPriceState.fingerprint = fingerprint;
      }
      gsPriceState.blocked = gsPriceState.id !== variant.id && gsPriceState.price !== variant.price;
      if (gsPriceState.blocked) {
        var activeCampaign = w.querySelector('.gs-vd-campaign-banner');
        out.unready = w.getAttribute('data-sub-mode') === 'subscribe' || !!(activeCampaign && activeCampaign.getClientRects().length);
        return out;
      }
      var settings = {};
      try { settings = JSON.parse(w.getAttribute('data-volume-settings') || '{}'); } catch (e) {}
      w.querySelectorAll('.gs-vd-radio-option').forEach(function (row) {
        var tier = list[Number(row.dataset.tierIndex)];
        var price = row.querySelector('.gs-vd-radio-price');
        if (!tier || !price) return;
        var cents = Math.round(Number(price.textContent.replace(/[^0-9.]/g, '')) * 100);
        var marker = row.querySelector('.gs-vd-each');
        var each = !!(marker && marker.getClientRects().length && getComputedStyle(marker).display !== 'none');
        var banner = w.querySelector('.gs-vd-campaign-banner');
        var campaign = w.getAttribute('data-sub-mode') === 'subscribe' || !!(banner && banner.getClientRects().length);
        var amount = displayedTotal(cents, tier.q, variant.price, list, !!settings.show_prices_per_item, each, campaign);
        if (amount !== undefined) out[tier.q] = amount;
      });
      return out;
    }
    function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
    function syncPdp() {
      var widget = document.getElementById('gs-volume-discount');
      if (mainShippingLine && widget && mainShippingLine.nextElementSibling !== widget) widget.before(mainShippingLine);
      var variant = selectedVariant();
      var lines = document.querySelectorAll('[data-bcb-aov-shipping]');
      var list = widgetTiers();
      var amounts = variant ? renderedTotals(list, variant) : {};
      var text = variant ? message(variant.price, limit, list, amounts, config.currency) : '';
      lines.forEach(function (line) {
        line.hidden = !shipping || !variant || !variant.available || amounts.unready;
        if (variant) { line.dataset.variantId = variant.id; line.dataset.price = variant.price; }
        setText(line, text);
      });
      var w = document.getElementById('gs-volume-discount');
      if (w) w.querySelectorAll('.gs-vd-radio-option').forEach(function (row) {
        var tier = list[Number(row.dataset.tierIndex)];
        var old = row.querySelector('[data-bcb-aov-tier]');
        var qualifies = shipping && !amounts.unready && !gsPriceState.blocked && variant && variant.available && tier && (amounts[tier.q] === undefined ? total(variant.price, tier.q, list) : amounts[tier.q]) >= limit;
        if (!qualifies) { if (old) old.remove(); return; }
        var target = row.querySelector('.gs-vd-title-row');
        if (!old && target) {
          var label = document.createElement('span');
          label.className = 'bcb-aov-tier'; label.dataset.bcbAovTier = '1'; label.textContent = 'Free shipping'; target.appendChild(label);
        }
      });
    }
    function syncPairs() {
      var anchor = document.querySelector('[data-bcb-pdp-form]');
      if (!anchor) return;
      var mount = document.querySelector('[data-bcb-aov-pairs]');
      var buy = document.getElementById('gs-volume-discount') || anchor.closest('[data-product-form-wrapper]');
      if (!buy) return;
      if (!mount) {
        mount = document.createElement('div'); mount.dataset.bcbAovPairs = '1'; mount.dataset.testid = 'bcb-aov-pairs';
      }
      // "Suggested additions" yorumların altında (Tunahan 29 Eki 2026, S11). Yorum bölümü varsa yerel öneri kendi
      // bölümünde (yorumların hemen altı) kalır, yer tutucu yalnız uygulama yedeğini taşır; yoksa eski yer: satın alma kutusunun altı.
      var reviews = document.querySelector('[id^="shopify-section-"][id$="__loox_reviews"]');
      var after = reviews || buy;
      if (after.nextElementSibling !== mount) after.insertAdjacentElement('afterend', mount);
      var native = document.querySelector('[data-bcb-recs][data-url*="intent=complementary"]');
      var nativeWrapper = native && native.closest('.bcb-pdp-recs');
      var nativeTarget = nativeWrapper || native;
      var count = native ? new Set(Array.from(native.querySelectorAll('a[href*="/products/"]')).map(function (a) { return a.pathname; })).size : 0;
      var cbb = document.querySelector('.cbb-frequently-bought-container');
      if (nativeTarget && count > 0 && (count >= 2 || !cbb)) {
        nativeTarget.hidden = false;
        if (!reviews && nativeTarget.parentElement !== mount) mount.appendChild(nativeTarget);
        if (cbb) cbb.hidden = true;
      } else if (cbb) {
        if (nativeTarget) nativeTarget.hidden = true;
        setText(cbb.querySelector('.cbb-frequently-bought-title'), 'Suggested additions');
        cbb.hidden = false;
        if (cbb.parentElement !== mount) mount.appendChild(cbb);
      }
      mount.hidden = !Array.prototype.some.call(mount.children, function (c) { return !c.hidden; });
    }
    function syncCartPrice() {
      if (!/(^|\/)cart\/?$/.test(location.pathname)) return;
      document.querySelectorAll('[data-cart-final]').forEach(function (el) {
        el.dataset.testid = 'bcb-aov-subtotal';
        setText(el, el.textContent.replace(/\b([A-Z]{3})(?:\s+\1)+\b/g, '$1'));
      });
    }
    function attach() {
      var container = document.querySelector('.gs_cart_drawer_content-wrapper-inner');
      if (!container) return false;
      var drawer = container.closest('.gs_cart_drawer');
      if (drawer && observedDrawer !== drawer) {
        if (drawerObserver) drawerObserver.disconnect();
        drawerObserver = new MutationObserver(refresh);
        drawerObserver.observe(drawer, {attributes: true, attributeFilter: ['class', 'style']});
        observedDrawer = drawer;
      }
      if (!block || !block.isConnected) {
        invalidateCart(); readVersion++; generation++;
        block = document.createElement('section'); block.className = 'bcb-aov-drawer'; block.dataset.bcbAov = '1'; block.dataset.testid = 'bcb-aov-drawer'; block.hidden = true;
        var before = document.getElementById('gs_cart_drawer_recommended_products_list');
        if (before && before.parentElement === container) container.insertBefore(block, before);
        else container.appendChild(block);
        signature = '';
        queueMicrotask(function () { refresh(); });
      }
      return true;
    }
    function element(tag, text, className) {
      var el = document.createElement(tag); if (text) el.textContent = text; if (className) el.className = className; return el;
    }
    function status(text) {
      if (!block) return;
      var el = block.querySelector('[data-bcb-aov-status]');
      if (!el) { el = element('p', '', 'bcb-aov-status'); el.dataset.bcbAovStatus = '1'; el.setAttribute('role', 'status'); block.appendChild(el); }
      setText(el, text); block.hidden = false;
    }
    async function add(item, expectedQuantity, suggestion) {
      if (busy) return;
      var core = gs();
      if (!core || typeof core.handleCartUpdate !== 'function') return;
      busy = true;
      block.setAttribute('aria-busy', 'true');
      block.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      var error, before, after, beforeEpoch, afterEpoch, posted = false, verified = false;
      try {
        beforeEpoch = cartEpoch;
        before = await getJson('cart.js?bcb_aov_check=' + Date.now());
        var same = before.items.find(function (i) { return i.id === Number(item.id) && JSON.stringify(i.properties || {}) === JSON.stringify(item.properties || {}) && !i.selling_plan_allocation; });
        var quantity = same ? same.quantity : 0;
        if (expectedQuantity !== undefined && (!same || quantity !== expectedQuantity)) throw new Error('Cart changed');
        if (expectedQuantity !== undefined) {
          var currentTiers = (same.properties || {})._gs_volume_tiers;
          if (!currentTiers && config.product && same.product_id === config.product.id) { var widget = document.getElementById('gs-volume-discount'); currentTiers = widget && widget.getAttribute('data-volume-tiers-raw'); }
          if (before.currency !== config.currency || !plusOne(before, same, limit, tiers(currentTiers))) throw new Error('Cart changed');
        }
        if (suggestion) {
          var liveProduct = await getJson('products/' + encodeURIComponent(suggestion.product.handle) + '.js');
          productCache.set(liveProduct.handle, Promise.resolve(liveProduct));
          var liveVariant = liveProduct.variants.find(function (v) { return v.id === Number(item.id) && v.available && v.price >= 100; });
          if (before.currency !== config.currency || excluded(liveProduct) || !liveVariant || liveVariant.price !== suggestion.variant.price || before.items.some(function (i) { return i.product_id === liveProduct.id; })) throw new Error('Suggestion changed');
          if (before.items.length) {
            var missing = limit - before.total_price;
            if (!shipping || missing <= 0 || liveVariant.price < missing || liveVariant.price > missing + 1500) throw new Error('Suggestion changed');
          }
        }
        var manager = core.getCartManager();
        invalidateCart();
        posted = true;
        var added;
        try { added = await manager.addToCart(item); } catch (e) { added = null; }
        // Even a failed/uncertain response may follow a committed add. Read it back.
        await core.handleCartUpdate({openDrawer: true, source: 'bcb-aov'});
        // Bounded read-verify loop: never repeat an additive POST, which can double
        // the order when another writer or an uncertain response is involved.
        for (var attempt = 0; attempt < 3; attempt++) {
          afterEpoch = cartEpoch;
          after = await getJson('cart.js?bcb_aov_check=' + Date.now());
          var found = after.items.find(function (i) { return i.id === Number(item.id) && JSON.stringify(i.properties || {}) === JSON.stringify(item.properties || {}) && !i.selling_plan_allocation; });
          if (found && found.quantity === quantity + 1 && afterEpoch === cartEpoch) { verified = true; break; }
          if (attempt < 2) await core.handleCartUpdate({openDrawer: true, source: 'bcb-aov-verify'});
        }
        if (!verified) throw new Error(added ? 'Cart verification failed' : 'Add failed');
        track('bcb_aov_add', {kind: expectedQuantity !== undefined ? 'plus_one' : suggestion ? suggestion.source || 'suggestion' : 'bestseller', variant_id: Number(item.id), missing: before.items.length ? limit - before.total_price : null, cart_total: after.total_price, reached: after.total_price >= limit});
        if ((expectedQuantity !== undefined || suggestion && before.items.length) && (after.currency !== config.currency || after.total_price < limit)) error = 'Added to your cart. Check the updated cart total.';
        if (!added) error = 'Check your cart to confirm the update.';
        signature = '';
      } catch (e) { error = posted ? 'We couldn’t confirm your cart update. Check your cart before adding again.' : 'Couldn’t update your cart. Check your cart before adding again.'; signature = ''; }
      finally {
        busy = false;
        var snapshot = verified ? {cart: after, epoch: afterEpoch} : !posted && before ? {cart: before, epoch: beforeEpoch} : true;
        await refresh(snapshot);
        if (error) status(error);
        if (block) { block.setAttribute('aria-busy', 'false'); block.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); }
      }
    }
    function addButton(text, id, properties, quantity, testid, suggestion) {
      var b = element('button', text, 'bcb-aov-add'); b.type = 'button'; b.dataset.testid = testid;
      var core = gs(); b.disabled = !core || typeof core.handleCartUpdate !== 'function' || typeof core.getCartManager !== 'function';
      b.addEventListener('click', function () { add({id: Number(id), quantity: 1, properties: properties || {}}, quantity, suggestion); });
      return b;
    }
    async function recommendations(cart, missing) {
      var data = await catalog();
      var handles = [], sources = {};
      if (!cart.items.length) handles = data.bestsellers;
      else {
        // Eksik tutar kuralı (b) (Tunahan 27 Eki 2026, [[2026-10-27-BCB-Sepet-75-Doldurma-Arastirmasi]]): önce elle kurulan
        // tamamlayıcı ilişkiler (intent=complementary), sonra Shopify related; marka/tür şartı yok. Sonra aynı marka/türden katalog adayları.
        var recs = function (intent) { return Promise.all(cart.items.slice(0, 3).map(function (i) { return getJson('recommendations/products.json?product_id=' + i.product_id + '&intent=' + intent + '&limit=10').catch(function () { return {products: []}; }); })); };
        var lists = await Promise.all([recs('complementary'), recs('related')]);
        lists.forEach(function (list, n) { list.forEach(function (r) { (r.products || []).forEach(function (p) { handles.push(p.handle); sources[p.handle] = sources[p.handle] || (n ? 'related' : 'complementary'); }); }); });
        data.candidates.forEach(function (p) { if (match(p, cart.items) && p.price >= missing && p.price <= missing + 1500) { handles.push(p.handle); sources[p.handle] = sources[p.handle] || 'catalog'; } });
      }
      handles = Array.from(new Set(handles)).filter(function (h) { return !cart.items.some(function (i) { return i.handle === h; }); });
      var found = [];
      for (var offset = 0; offset < Math.min(handles.length, 40) && found.length < (cart.items.length ? 3 : 4); offset += 4) {
        var rows = await Promise.all(handles.slice(offset, offset + 4).map(product));
        rows.forEach(function (p) {
          if (excluded(p) || cart.items.some(function (i) { return i.product_id === p.id; })) return;
          var v = cart.items.length ? variantFor(p, missing) : p.variants.find(function (v) { return v.available && v.price >= 100; });
          if (!v || found.some(function (r) { return r.product.id === p.id; })) return;
          found.push({product: p, variant: v, source: sources[p.handle] || 'bestseller'});
        });
      }
      // Vendors/types outside the top-seller catalog still get a live search fallback.
      if (cart.items.length && found.length < 3) {
        var terms = Array.from(new Set([cart.items[0].vendor, cart.items[0].product_type].filter(Boolean))).slice(0, 2);
        var results = await Promise.all(terms.map(search));
        var extra = [];
        results.forEach(function (r) {
          var products = r.resources && r.resources.results && r.resources.results.products || [];
          products.forEach(function (p) { var slug = p.handle || ((p.url || '').match(/\/products\/([^?/#]+)/) || [])[1]; if (slug) extra.push(slug); });
        });
        extra = Array.from(new Set(extra)).filter(function (h) { return !handles.includes(h) && !cart.items.some(function (i) { return i.handle === h; }); });
        for (var start = 0; start < Math.min(extra.length, 16) && found.length < 3; start += 4) {
          var live = await Promise.all(extra.slice(start, start + 4).map(product));
          live.forEach(function (p) {
            if (excluded(p) || !match(p, cart.items) || cart.items.some(function (i) { return i.product_id === p.id; }) || found.some(function (r) { return r.product.id === p.id; })) return;
            var v = variantFor(p, missing); if (v) found.push({product: p, variant: v, source: 'search'});
          });
        }
      }
      return found.slice(0, cart.items.length ? 3 : 4);
    }
    async function refresh(cartOrForce) {
      if (cartOrForce === true) invalidateCart();
      if (cartOrForce && cartOrForce.cart && Array.isArray(cartOrForce.cart.items)) {
        cartRead = null; readVersion++; generation++;
        if (!confirmCart(cartOrForce.cart, cartOrForce.epoch)) invalidateCart();
      }
      if (busy) return;
      if (!attach()) { wasDrawerOpen = false; return; }
      if (!(gs() && gs().isDrawerOpen) && !document.querySelector('.gs_cart_drawer.active')) { wasDrawerOpen = false; return; }
      if (!wasDrawerOpen) {
        invalidateCart();
        announce = true;
        // Sepet görüntüleme sayımı: kapalı→açık geçişi başına bir olay; theme.liquid örnekleyicisinden muaf (29 Eki 2026).
        var opened; try { opened = gs() && typeof gs().getCart === 'function' && gs().getCart(); } catch (e) {}
        track('bcb_cart_drawer_opened', {item_count: opened && typeof opened.item_count === 'number' ? opened.item_count : null});
      }
      wasDrawerOpen = true;
      var readTicket = ++readVersion;
      var cart;
      try {
        cart = await displayCart();
      } catch (e) { if (readTicket === readVersion && !busy) { block.replaceChildren(); block.hidden = true; } return; }
      if (readTicket !== readVersion || busy) return;
      t1Drawer(cart);
      var key = cartKey(cart);
      if (key === signature) { shown(cart); return; }
      var ticket = ++generation;
      signature = key;
      block.replaceChildren();
      if (cart.currency !== config.currency || (cart.items.length && (!shipping || cart.total_price >= limit))) { block.hidden = true; return; }
      block.hidden = false;
      var missing = Math.max(0, limit - cart.total_price);
      block.appendChild(element('p', cart.items.length ? money(missing, config.currency) + ' away from free shipping' : 'Bestsellers', 'bcb-aov-heading'));
      var text = element('p', '', 'bcb-aov-status'); text.dataset.bcbAovStatus = '1'; text.setAttribute('role', 'status'); block.appendChild(text);
      if (cart.items.length) cart.items.forEach(function (item) {
        var raw = (item.properties || {})._gs_volume_tiers;
        if (!raw && config.product && item.product_id === config.product.id) {
          var currentWidget = document.getElementById('gs-volume-discount');
          raw = currentWidget && currentWidget.getAttribute('data-volume-tiers-raw');
        }
        var list = tiers(raw);
        if (plusOne(cart, item, limit, list)) {
          var row = element('div', '', 'bcb-aov-quantity'); row.appendChild(element('span', item.product_title));
          row.appendChild(addButton('+1 = free shipping', item.id, item.properties, item.quantity, 'bcb-aov-quantity-add')); block.appendChild(row);
        }
      });
      if ((!cart.items.length || missing <= 1500) && cart.currency === 'USD') {
        var link = element('a', 'Shop under $15', 'bcb-aov-under'); link.href = url('collections/under-15'); link.dataset.testid = 'bcb-aov-under-15'; block.appendChild(link);
      }
      var listNode = element('div', '', 'bcb-aov-products'); block.appendChild(listNode);
      var rows = await recommendations(cart, missing);
      if (ticket !== generation || busy || !block.isConnected) return;
      rows.forEach(function (row) {
        var p = row.product, v = row.variant;
        var card = element('article', '', 'bcb-aov-card'); card.dataset.productId = p.id; card.dataset.vendor = p.vendor; card.dataset.productType = p.type; card.dataset.price = v.price; card.dataset.source = row.source || '';
        var link = element('a', '', 'bcb-aov-card-link'); link.href = url('products/' + encodeURIComponent(p.handle) + '?variant=' + v.id);
        if (p.featured_image) { var img = element('img'); img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=120'; img.alt = ''; img.width = 60; img.height = 60; img.loading = 'lazy'; link.appendChild(img); }
        var name = element('span', p.title); link.appendChild(name); card.appendChild(link);
        card.appendChild(element('span', money(v.price, cart.currency), 'bcb-aov-price'));
        card.appendChild(addButton('Add to cart', v.id, {}, undefined, 'bcb-aov-product-add', row)); listNode.appendChild(card);
      });
      if (!rows.length && !block.querySelector('button') && !block.querySelector('.bcb-aov-under')) block.hidden = true;
      shownKey = key;
      shown(cart);
    }
    // T1 testi (hipotez 11 + teslim satırı, Tunahan 30 Eki 2026): PostHog bayrağı bcb-t1-kargo-satiri "test" kolunda ABD
    // ziyaretçisine PDP fiyatının altında ve GS çekmecesinde iki satır; "control", bayraksız ya da okunamayan bayrak A (bugünkü görünüm).
    // Bayrak (ve $feature_flag_called) yalnız ABD'de, satırın çıkacağı yüzey açılınca okunur. Metinler harfi harfine onaylı ve ABD
    // kargo bölgesine (Standard Delivery: 74,99 $ ve üstü ücretsiz, altı 9,99 $) bağlı: eşik 75 $ değilse çizilmez. Teslim satırı Standard yolunun süresi
    // (3-5 + 3-6 iş günü): seçili ya da sepetteki kargo US Stock / Ready to Ship ise ya da sepet boşsa yalnız ücret satırı çizilir.
    var t1 = {key: 'bcb-t1-kargo-satiri', arm: 'A', asked: false, fast: /US Stock|Ready to Ship/i,
      fee: 'Free US shipping on orders of $75 or more. Under $75, shipping is $9.99.', eta: 'Arrives in 6-11 business days in the US'};
    var t1Eligible = shipping && config.country === 'US' && limit === 7500;
    function t1Ask() {
      var ph = window.posthog;
      if (t1.asked || !t1Eligible || !ph || typeof ph.onFeatureFlags !== 'function') return;
      t1.asked = true;
      ph.onFeatureFlags(function () {
        // window.posthog yeniden okunur: ilk okunan nesne yükleme öncesi kuyruk taslağı olabilir (getFeatureFlag'i boş döner)
        var value; try { value = window.posthog.getFeatureFlag(t1.key); } catch (e) {}
        t1.arm = value === 'test' ? 'B' : 'A';
        syncT1(); refresh();
      });
    }
    // data-bcb-aov: gövde gözlemcisi kendi yazdığımız düğümü yeni olay saymasın; kutu bir kez kurulur, sonra yalnız gizle/göster.
    function t1Box(box, eta) {
      if (!box.firstChild) { box.appendChild(element('p', t1.fee, 'bcb-t1__fee')); box.appendChild(element('p', t1.eta, 'bcb-t1__eta')); }
      if (box.lastChild.hidden !== !eta) box.lastChild.hidden = !eta;
      if (box.hidden !== (t1.arm !== 'B')) box.hidden = t1.arm !== 'B';
    }
    function t1Make(where) {
      var box = element('div', '', 'bcb-t1 bcb-t1--' + where); box.dataset.bcbAov = '1'; box.dataset.bcbT1 = where; box.dataset.testid = 'bcb-t1-' + where; box.hidden = true; return box;
    }
    function syncT1() {
      if (!config.product || !t1Eligible) return;
      var offer = document.querySelector('[data-bcb-pdp] .bcb-pdp__offer');
      if (!offer) return;
      t1Ask();
      var box = offer.parentElement.querySelector('[data-bcb-t1="pdp"]');
      if (!box) { if (t1.arm !== 'B') return; box = t1Make('pdp'); offer.insertAdjacentElement('afterend', box); }
      var ship = document.querySelector('[data-testid="bcb-pdp-shipping"] input:checked');
      t1Box(box, !ship || !t1.fast.test(ship.value));
    }
    // Yalnız refresh()'in çekmece açık dalından, sepet okunduktan sonra çağrılır: çekmece kapalıyken bayrak okunmaz.
    function t1Drawer(cart) {
      if (!t1Eligible) return;
      t1Ask();
      if (!block || !block.parentElement) return;
      var box = block.parentElement.querySelector('[data-bcb-t1="drawer"]');
      if (!box) { if (t1.arm !== 'B') return; box = t1Make('drawer'); block.parentElement.insertBefore(box, block); }
      t1Box(box, cart.items.length > 0 && !cart.items.some(function (i) { return t1.fast.test(i.variant_title || ''); }));
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; syncPdp(); syncPairs(); syncCartPrice(); attach(); syncT1(); });
    }
    ['cart_changed_gs', 'cart_discount_changed_gs'].forEach(function (event) { window.addEventListener(event, function () { refresh(true); }); });
    // GS emits these on rendering even when its cart has not changed. Deduplicate
    // the render notification, never use its snapshot as our server-read cache.
    ['gsCartTotalUpdated', 'gs:incentives:updated'].forEach(function (event) {
      window.addEventListener(event, function () {
        var core = gs(), key = cartKey(core && typeof core.getCart === 'function' && core.getCart());
        if (key && key !== renderedGsKey) { renderedGsKey = key; refresh(true); }
        else refresh();
      });
    });
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
    var observer = new MutationObserver(function (records) {
      if (records.some(function (r) { var target = r.target instanceof Element ? r.target : r.target.parentElement; return !target || !target.closest('[data-bcb-aov], [data-bcb-aov-tier], [data-bcb-aov-shipping]'); })) schedule();
    });
    observer.observe(document.body, {childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-current-variant-id', 'data-sub-mode', 'data-volume-settings']});
    schedule(); refresh();
    document.addEventListener('click', function (e) { if (e.target.closest('[data-gs-cart-hijacked]')) refresh(); }, true);
  }
  return {tiers: tiers, total: total, message: message, displayedTotal: displayedTotal, plusOne: plusOne, excluded: excluded, match: match, variantFor: variantFor, mount: mount};
});
